import * as React from 'react';
import ContentStatus from '../../components/ContentStatus';
import { connect } from 'react-redux';
import { Country } from '../../models/country/Country';
import * as DialogStore from '../../store/DialogStore';
import { httpService } from '../../index';
import { ApplicationState } from '../../store';
import * as CountryStore from '../../store/CountryStore';
import { DetailsBase } from '../base/DetailsBase';
import DetailsHeader from '../../components/DetailsHeader';
import { Helpers } from '../../utility/Helpers';


class CountryDetails extends DetailsBase<Country> {

    constructor(props: any) {
        super(props);
        this.getItem = async (id: string) => {
            let res = await httpService.getCountry(id);
            return res;
        }
        this.saveItem = async (data: Country) => { return await httpService.countryAddOrUpdate(data) }
        this.deleteItemCall = async (id: string) => { return await httpService.countryDelete(id) }
    }



    render() {
        return (
            <div>
                <DetailsHeader baseUrl="country" data={this.state.data}
                               title={this.state.data ? this.state.data.name : "Country Preview"} onDelete={() => {
                    this.deleteItem()
                }}/>

                <ContentStatus isLoading={this.state.isLoading} errorMessage={this.state.error} data={this.state.data}></ContentStatus>
                {(this.state && this.state.data) &&
                    <div>
                        <div className="row">

                            <div className="mb-1 col-md-3">Created:</div>
                            <div className="mb-1 col-md-9"> {Helpers.getLocalDateTimeString(this.state.data.created)}</div>

                        </div>
                        <div className="row">

                            <div className="mb-1 col-md-3">Name:</div>
                            <div className="mb-1 col-md-9"> {this.state.data.name}</div>

                        </div>
                        <div className="row">

                            <div className="mb-1 col-md-3">Phoen Prefix:</div>
                            <div className="mb-1 col-md-9"> {this.state.data.phonePrefix}</div>

                        </div>
                        <div className="row">

                            <div className="mb-1 col-md-3">ISO2:</div>
                            <div className="mb-1 col-md-9"> {this.state.data.isO2}</div>

                        </div>
                        <div className="row">

                            <div className="mb-1 col-md-3">ISO3:</div>
                            <div className="mb-1 col-md-9"> {this.state.data.isO3}</div>

                        </div>
                        
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return { dataState: state.countryList };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        selectItem: (data: Country) => { dispatch(CountryStore.actionCreators.selectItem(data)) },
        getItems: () => { dispatch(CountryStore.actionCreators.getItems()) },
        setImageEditData: (image: any) => { dispatch(DialogStore.actionCreators.setImageEditData(image)) },
        increment: () => { dispatch(DialogStore.actionCreators.increment()) },
        decrement: () => { dispatch(DialogStore.actionCreators.decrement()) },
        showNotification: (data: DialogStore.NotificationData) => { dispatch(DialogStore.actionCreators.showNotification(data)) },
        showDialog: (m: string, t: DialogStore.DialogType, cal: Function) => { dispatch(DialogStore.actionCreators.showDialog(m, t, cal)) }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CountryDetails);
